"use client";
import Script from "next/script";
import { useEffect } from "react";

export const OneTrustCookieConsentScript = () => {
  useEffect(() => {
    // Remove the style attribute from the button to show the manage cookies button in the UniversalFooter, copied from the Google Tag Manager approach for consistency:
    // https://gitlab.com/zapier/design-systems/design-system/-/blob/main/packages/universal-layout/src/universal-footer/components/UniversalFooter/UniversalFooter.tsx#L209
    const manageCookiesButton = document.querySelector(".ot-sdk-show-settings");
    if (manageCookiesButton) {
      manageCookiesButton.removeAttribute("style");
    }
  }, []);

  return (
    <Script
      data-domain-script={process.env.NEXT_PUBLIC_ONE_TRUST_DOMAIN_ID}
      id="onetrust-cookie-consent-script"
      src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
      strategy="beforeInteractive"
      type="text/javascript"
    />
  );
};
